import {z} from "../../../lib";
import { EntityWithId, schemaEntityWithId } from 'src/types'
import {SistemaTipo} from "../../../types/enum/enum";

export const MensajeFields = {
    CodigoSistema: 'codSistema',
    CodigoSistemaPrincipal: 'codSistemaPrincipal',
    IdEtapaActual: 'idEtapaActual',
    FechaIngresoEtapa: 'fechaIngresoEtapa',
    Referencia: 'referencia',
    FechaCreacion: 'fechaCreacion',
    NombreSistema: 'nombreSistema',
    NombreSistemaPrincipal: 'nombreSistemaPrincipal',
    NombreEtapaActual: 'nombreEtapaActual',
    CodSistemaTipo: 'codSistemaTipo',
    BitAbierto: 'bitAbierto',
    DiasEnEtapa: 'diasEnEtapa',
    CodEtapaEstado: 'codEtapaEstado',
    DescEtapaEstado: 'descEtapaEstado',
    HexColor: 'hexColor',
    Estado: 'estado',
    OperacionId: 'idOperacion',
} as const

export const schemaMensaje = z.object({
    [MensajeFields.CodigoSistema]: z.number(),
    [MensajeFields.CodigoSistemaPrincipal]: z.number(),
    [MensajeFields.IdEtapaActual]: z.number(),
    [MensajeFields.FechaIngresoEtapa]: z.string(),
    [MensajeFields.Referencia]: z.string(),
    [MensajeFields.FechaCreacion]: z.string(),
    [MensajeFields.NombreSistema]: z.string(),
    [MensajeFields.NombreSistemaPrincipal]: z.string(),
    [MensajeFields.NombreEtapaActual]: z.string(),
    [MensajeFields.CodSistemaTipo]: z.nativeEnum(SistemaTipo),
    [MensajeFields.BitAbierto]: z.boolean(),
    [MensajeFields.DiasEnEtapa]: z.number(),
    [MensajeFields.CodEtapaEstado]: z.number(),
    [MensajeFields.DescEtapaEstado]: z.string(),
    [MensajeFields.HexColor]: z.string(),
    [MensajeFields.Estado]: z.string(),
}).merge(schemaEntityWithId)

export type Mensaje = EntityWithId & {
    [MensajeFields.CodigoSistema]: number
    [MensajeFields.CodigoSistemaPrincipal]: number
    [MensajeFields.IdEtapaActual]: number
    [MensajeFields.FechaIngresoEtapa]: string
    [MensajeFields.Referencia]: string
    [MensajeFields.FechaCreacion]: string
    [MensajeFields.NombreSistema]: string
    [MensajeFields.NombreSistemaPrincipal]: string
    [MensajeFields.NombreEtapaActual]: string
    [MensajeFields.CodSistemaTipo]: SistemaTipo
    [MensajeFields.BitAbierto]: boolean
    [MensajeFields.DiasEnEtapa]: number
    [MensajeFields.CodEtapaEstado]: number
    [MensajeFields.DescEtapaEstado]: string
    [MensajeFields.HexColor]: string
    [MensajeFields.Estado]: string
}

